var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation2269(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.587,
    height: 13.315,
    viewBox: "0 0 11.587 13.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2269",
    "data-name": "Group 2269",
    transform: "translate(-178.4 -451.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M9,9.948A1.948,1.948,0,1,0,10.948,8,1.948,1.948,0,0,0,9,9.948",
    transform: "translate(173.246 447.246)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M12.866,11.866,10.111,14.62a1.3,1.3,0,0,1-1.835,0L5.521,11.866a5.193,5.193,0,1,1,7.345,0Z",
    transform: "translate(175 449)",
    fill: "none",
    stroke: "#4f2532",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2269);
export default __webpack_public_path__ + "static/media/location2269.3903cd48dd30bda08a25fd4bd2da355e.svg";
export { ForwardRef as ReactComponent };